module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Regular.65fe67a.ttf";